<template>
  <section :class="$style.parts_container" class="parts-container">
    <div :class="$style.banner_button_area">
      <div :class="$style.banner_image">
        <AtomsConsumerImage :src="imgUrl" :alt="imgUrlCaption" :class="{ 'page-parts-pc': !!spImgUrl }" />
        <AtomsConsumerImage v-if="spImgUrl" :src="spImgUrl" :alt="spImgUrlCaption" class="page-parts-sp" />
      </div>
      <div :class="[$style.banner_text, textAlignStyle]">
        <h3
          :class="[$style.title, fontSize, { 'page-parts-pc': !!spTitle }]"
          :style="{ color: textColorRef }"
          v-html="sanitizeHtmlContent(title)"
        ></h3>
        <h3
          v-if="spTitle"
          class="page-parts-sp"
          :class="[$style.title, fontSize]"
          :style="{ color: textColorRef }"
          v-html="sanitizeHtmlContent(spTitle)"
        ></h3>
        <p
          :class="[$style.description, descFontSize, { 'page-parts-pc': !!spDescription }]"
          :style="{ color: textColorRef }"
          v-html="sanitizeHtmlContent(description)"
        ></p>
        <p
          v-if="spDescription"
          class="page-parts-sp"
          :class="[$style.description, descFontSize]"
          :style="{ color: textColorRef }"
          v-html="sanitizeHtmlContent(spDescription)"
        ></p>

        <AtomsConsumerLink
          v-if="linkText"
          :url="linkUrl"
          :style="{ background: linkBgColorRef, color: linkTextColorRef }"
          :class="$style.link_text"
          >{{ linkText }}</AtomsConsumerLink
        >
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"
type Props = {
  title?: string
  spTitle?: string
  description?: string
  spDescription?: string
  fontSize: string[]
  descFontSize: string[]
  color?: string
  imgUrl: string
  spImgUrl?: string | null
  imgUrlCaption?: string
  spImgUrlCaption?: string
  linkUrl?: string
  linkText?: string
  linkTextColor?: string
  linkBgColor?: string
  textAlign?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  spTitle: "",
  description: "",
  spDescription: "",
  color: "",
  imgUrl: "",
  spImgUrl: null,
  imgUrlCaption: "",
  spImgUrlCaption: "",
  linkText: "",
  linkTextColor: "#000",
  linkBgColor: "#fff",
  textAlign: "",
  linkUrl: "",
})

const linkBgColorRef = computed(() => {
  return props.linkBgColor || "#fff"
})
const linkTextColorRef = computed(() => {
  return props.linkTextColor || "#6F7179"
})
const textColorRef = computed(() => {
  return props.color || "#fff"
})

const style = useCssModule()
const textAlignStyle = computed(() => {
  return props.textAlign === "right" ? style.right : ""
})
</script>

<style scoped module lang="scss">
.parts_container {
  @include full-container-md;

  .banner_button_area {
    position: relative;
    .banner_image {
      width: 100%;
      max-height: 450px;

      @include sp {
        aspect-ratio: 1;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: top;
      }
    }
    .banner_text {
      position: absolute;
      bottom: 14%;
      left: 10%;
      &.right {
        left: auto;
        right: 10%;
        @include sp {
          left: 50%;
          right: auto;
        }
      }

      @include sp {
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        bottom: 10%;
      }
      .title {
        color: $white;
        font-size: $font-size-18;
        line-height: 1.611;
        font-weight: 700;
        margin-bottom: 7px;

        @include sp {
          margin-bottom: 4px;
          font-size: $font-size-15;
          letter-spacing: 0.15em;
        }
      }
      .description {
        color: $white;
        font-size: $font-size-17;
        line-height: 2.11;
        font-weight: 700;
        margin-bottom: 1.25rem;
        white-space: pre-wrap;
        @include sp {
          line-height: 1.6;
          margin-bottom: 1.25rem;
          font-size: $font-size-18;
          letter-spacing: 0.07em;
        }
      }
      .link_text {
        font-size: $font-size-13;
        line-height: 1.38;
        letter-spacing: 0.15em;
        text-align: center;
        padding: 8.5px 1.42rem;
        text-decoration: none;
        background-color: $white;
        border-radius: 9999px;
        color: #6f7179;
        display: inline-block;

        @include sp {
          padding: 0.6875rem 2.03rem;
        }
      }
    }
  }
}
</style>
